/**
 * LecomaStudio scroll reveal.
 * [data-lc-reveal] fades up once; [data-lc-reveal-stagger] reveals its children in sequence.
 * The hidden start state is keyed on html.lc-js, which is added here, so no-JS and
 * reduced-motion visitors always see all content.
 */
(function () {
  if (window.__lcReveal) return;
  window.__lcReveal = true;
  var root = document.documentElement;
  var selector = '[data-lc-reveal],[data-lc-reveal-stagger]';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ioWorks = false;

  // Fallback: if the observer never reported anything, reveal everything.
  function revealAll() {
    if (ioWorks) return;
    document.querySelectorAll(selector).forEach(function (el) {
      el.classList.add('lc-in');
    });
  }

  var hasIO = 'IntersectionObserver' in window;
  var io = hasIO
    ? new IntersectionObserver(
        function (entries) {
          // First callback proves the observer works; this also cancels the CSS-only safety net.
          if (!ioWorks) {
            ioWorks = true;
            root.classList.add('lc-ready');
          }
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('lc-in');
            io.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
      )
    : null;

  function inViewport(el) {
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight || root.clientHeight;
    return rect.top < vh * 0.9 && rect.bottom > 0;
  }

  function scan(scope) {
    scope.querySelectorAll(selector).forEach(function (el) {
      if (el.hasAttribute('data-lc-seen')) return;
      el.setAttribute('data-lc-seen', '');
      var delay = parseInt(el.getAttribute('data-lc-reveal'), 10);
      if (delay > 0) el.style.transitionDelay = delay + 'ms';
      // Already visible at init: reveal right away; the observer handles the rest.
      if (!io || inViewport(el)) {
        el.classList.add('lc-in');
      } else {
        io.observe(el);
      }
    });
  }

  // Accordion height transition (250ms) on native <details>; without JS they still open/close.
  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('.lc-faq__question, .lc-accordion__summary');
    if (!summary || !summary.parentElement || summary.parentElement.tagName !== 'DETAILS') return;
    var item = summary.parentElement;
    if (item.getAnimations && item.getAnimations().length) return event.preventDefault();
    if (!item.animate) return;
    event.preventDefault();
    var start = item.offsetHeight;
    var opening = !item.open;
    item.style.overflow = 'hidden';
    if (opening) item.open = true;
    var border = item.offsetHeight - item.clientHeight;
    var end = (opening ? item.scrollHeight : summary.offsetHeight) + border;
    var anim = item.animate({ height: [start + 'px', end + 'px'] }, { duration: 250, easing: 'ease' });
    anim.onfinish = function () {
      if (!opening) item.open = false;
      item.style.overflow = '';
    };
  });

  root.classList.add('lc-js');
  scan(document);
  // Safety net: never leave content hidden if the observer is slow, blocked or never fires.
  window.setTimeout(revealAll, 2000);
  // Elements in the bottom 10% at max scroll can never cross the observer margin: reveal them at page end.
  if (io) {
    window.addEventListener(
      'scroll',
      function () {
        if (window.innerHeight + window.scrollY < root.scrollHeight - 2) return;
        document.querySelectorAll(selector).forEach(function (el) {
          if (el.classList.contains('lc-in')) return;
          el.classList.add('lc-in');
          io.unobserve(el);
        });
      },
      { passive: true }
    );
  }
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target || document);
  });
})();
